export const RequestIcon = () => {
  return (
    <svg
      className="ic_request"
      id="レイヤー_1"
      data-name="レイヤー 1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <title>ic_request</title>
      <rect width="32" height="32" fill="none" />
      <path
        d="M16.87,2.51l15,26A1,1,0,0,1,31,30H1a1,1,0,0,1-.86-1.5l15-26A1,1,0,0,1,16.87,2.51Zm-1.3,9-7.52,13a.5.5,0,0,0,.43.75h15a.5.5,0,0,0,.43-.75l-7.52-13A.49.49,0,0,0,15.57,11.54Z"
        fill="#fc0"
      />
    </svg>
  );
};
